import { observable } from "mobx";

// const { open, title, styles, className, classContainer, loading, saving, body, errorMessage, cancelLabel, okLabel, hideCancel, hideOk, disableOk, onClickOk, onClickCancel, resetOnSave, buttons } = options;
// const configurationLayout = { 
//     open: true,
//     title: "",
//     className: "",
//     styles: {
//         dialog: {}
//     }, 
//     classContainer: "",
//     loading: false,
//     saving: false,
//     body: <p>Something</p>,
//     errorMessage: "",
//     cancelLabel: "CANCELAR",
//     okLabel: "CONFIRMAR",
//     hideCancel: false,
//     hideOk: false,
//     disableOk: false,
//     onClickOk: () => {},
//     onClickCancel: () => {},
//     resetOnSave: false,
//     buttons: [
//         {
//             label: "CLIQUE AQUI",
//             onClick: () => {},
//             reset: true,
//         }
//     ]
// };
export default class ModalStore {

    @observable configurableModalArray;

    constructor() {
        this.configurableModalArray = [];
    }

    modalExists = (id) => this.configurableModalArray.find(m => m.id === id);

    modalIsTopLevel = (id) => this.configurableModalArray.findIndex(m => m.id === id) === 0;
    
    getUniqueId = (length = 16) => {
        let id = parseInt(Math.ceil(Math.random() * Date.now()).toPrecision(length).toString().replace(".", ""));
        if (this.modalExists(id)) id = this.getUniqueId(length);
        return id;
    }
    
    addConfigurableModal = (configurableModal) => {
        if (!configurableModal.id) throw new Error("Invalid Id");

        if (this.modalExists(configurableModal.id)) this.destroyConfigurableModal(configurableModal.id);

        this.configurableModalArray.unshift(configurableModal);
    }

    destroyConfigurableModal = (modalId) => {
        this.configurableModalArray = this.configurableModalArray.filter(m => m.id !== modalId);
    }

    /**
     * Cria e abre uma nova modal
     * @param {string | object} title Título da modal ou o objeto de configuração
     * @param {object} options Configuração inicial
     * @returns A instancia da modal criada
     */
    openNewConfigurableModal = (title, { open, styles, className, classContainer, loading, saving, body, errorMessage, cancelLabel, okLabel, hideCancel, hideOk, disableOk, onClickOk, onClickCancel, onOpen, resetOnSave, buttons } = {}) => 
        new this.ConfigurableModal(title, { open, styles, className, classContainer, loading, saving, body, errorMessage, cancelLabel, okLabel, hideCancel, hideOk, disableOk, onClickOk, onClickCancel, onOpen, resetOnSave, buttons });

    /**
     * Cria e abre uma nova modal
     * @param {string | object} title Título da modal ou o objeto de configuração
     * @param {object} options Configuração inicial
     * @returns A instancia da modal criada
     */
    ConfigurableModal = (title, { open, styles, className, classContainer, loading, saving, body, errorMessage, cancelLabel, okLabel, hideCancel, hideOk, disableOk, onClickOk, onClickCancel, onOpen, resetOnSave, buttons } = {}) => 
        new ConfigurableModal({ title: typeof title == 'string' ? title : "", ...{ open, styles, className, classContainer, loading, saving, body, errorMessage, cancelLabel, okLabel, hideCancel, hideOk, disableOk, onClickOk, onClickCancel, onOpen, resetOnSave, buttons }, ...(typeof title == 'object' ? title : {}) }, this);
}

class ConfigurableModal {
    id;
    
    @observable configuration;

    constructor(options, modalStore) {
        this.id = modalStore.getUniqueId();

        this.modalExists = () => modalStore.modalExists(this.id);
        this.modalIsTopLevel = () => modalStore.modalIsTopLevel(this.id);
        this.modalSetter = modalStore.addConfigurableModal;
        this.modalCloser = modalStore.destroyConfigurableModal;

        const { open = true, title, styles = {}, className = "", classContainer = "", loading = false, saving = false, body, errorMessage = "", cancelLabel = "FECHAR", okLabel = "OK", hideOk, hideCancel, disableOk = false, onClickOk, onClickCancel, onOpen, resetOnSave = true, buttons } = options;
        
        const isUndefined = (prop) => typeof prop == 'undefined';

        if (!body && !title && !loading) throw new Error("At least one prop for the body must be defined (body, title or loading)");
        
        const hasExtraButtons = !isUndefined(buttons) && Array.isArray(buttons) && buttons.length > 0;

        this.configuration = {
            open,
            title: isUndefined(title) ? "Atenção!" : title,
            styles,
            className,
            classContainer,
            loading,
            saving,
            body: isUndefined(body) ? null : body,
            errorMessage,
            cancelLabel,
            okLabel,
            hideCancel: isUndefined(hideCancel) && hasExtraButtons ? true : hideCancel,
            hideOk: isUndefined(hideOk) && hasExtraButtons ? true : hideOk,
            disableOk,
            onClickOk: (...args) => typeof onClickOk == 'function' ? onClickOk(...args) : () => {},
            onClickCancel: (...args) => typeof onClickCancel == 'function' ? onClickCancel(...args) : () => {},
            onOpen: (...args) => typeof onOpen == 'function' ? onOpen(...args) : () => {},
            resetOnSave,
            buttons: hasExtraButtons ? [...buttons] : [],
        };

        this.modalSetter(this);
    }

    setConfigurableModal = (config) => {
        switch (typeof config) {
            case 'function':
                config = config(this.configuration);
                break;
            case 'object':
                config = Object.assign({}, config);
                break;
            case 'string':
                config = Object.assign({}, { title: config });
                break;
            default: throw new Error("unsupported argument type");
        }
        this.configuration = config;
    }

    appendConfigurableModal = (config) => {
        switch (typeof config) {
            case 'function':
                config = config(this.configuration);
            case 'object':
                config = Object.assign(this.configuration, config);
                break;
            case 'string':
                config = Object.assign(this.configuration, { title: config });
                break;
            default: throw new Error("unsupported argument type");
        }
        this.configuration = config;
    }
    
    open = () => {
        this.appendConfigurableModal({ open: true });
        if (!this.modalExists()) this.modalSetter(this);
    }
    
    close = () => this.appendConfigurableModal({ open: false });
    
    destroy = () => this.modalCloser(this.id);

    get isTopLevel() {
        return this.modalIsTopLevel();
    }

    setErrorMessage = (error) => {
        let errorMessage;
        if (error instanceof Error)
            errorMessage = error.message;
        else if (typeof error == 'string')
            errorMessage = error;
        else if (typeof error.Message == 'string')
            errorMessage = error.Message;
        else
            errorMessage = 'Ocorreu um erro!';
        
        this.appendConfigurableModal({ errorMessage });
    }

    setLoading = (loading) => this.appendConfigurableModal({ loading: !!loading });

    toggleLoading = () => this.appendConfigurableModal(({ loading }) => ({ loading: !loading }));
    
    setSaving = (saving) => this.appendConfigurableModal({ saving: !!saving });
    
    toggleSaving = () => this.appendConfigurableModal(({ saving }) => ({ saving: !saving }));
}; 



// WEBPACK FOOTER //
// ./src/modules/comum/modal/stores/ModalStore.js